import { getParsedRowByIdOrIndex } from "./rowHelpers";
import { isMultiRowPg } from "./uploadRowsHelpers";

export const isDittaIndividuale = (item, isAlphaNumericFn) => {
  const cf = (item[15] || "").trimStart().trimEnd();
  const pIva = (item[9] || "").trimStart().trimEnd();

  return pIva !== "" && cf !== "" && cf !== pIva && cf.length === 16 && isAlphaNumericFn(cf) && item[6].trimStart().trimEnd() === "DI" && item[3].trimStart().trimEnd() === "S";
};

export const isDittaIndividualeMulti = (item, isAlphaNumericFn) => {
  const cf = (item[15] || "").trimStart().trimEnd();
  const pIva = (item[9] || "").trimStart().trimEnd();

  return pIva !== "" && cf !== "" && cf !== pIva && cf.length === 16 && isAlphaNumericFn(cf);
};

export const isPurePgRow = (item, isAlphaNumericFn) =>
  !isDittaIndividuale(item, isAlphaNumericFn) && (item[3] || "").trim() !== "S";

export const parseLegaleRappNomeCognomeFromItem = (item) => {
  const raw = (item[29] || "").trim();
  const words = raw.split(/\s+/).filter(Boolean);
  if (words.length < 2) return null;
  return {
    cognome: words[0],
    nome: words.slice(1).join(" "),
  };
};

const getRowImportPriority = ({ item, selImportType, isAlphaNumericFn }) => {
  const rowDetails = getConfirmRowDetails({ item, selImportType, isAlphaNumericFn });

  if (!rowDetails.isPg) {
    return 1;
  }

  if (isDittaIndividuale(item, isAlphaNumericFn)) {
    return 2;
  }

  return 3;
};

export const orderSelectedRowsByImportPriority = ({
  selectedRows,
  parsedValues,
  selImportType,
  isAlphaNumericFn,
}) => {
  const rowsWithPriority = selectedRows.map((rowId, index) => {
    const item = getParsedRowByIdOrIndex(parsedValues, rowId);

    if (!item || !Array.isArray(item)) {
      return { rowId, index, priority: 3 };
    }

    return {
      rowId,
      index,
      priority: getRowImportPriority({ item, selImportType, isAlphaNumericFn }),
    };
  });

  rowsWithPriority.sort((a, b) => {
    if (a.priority === b.priority) {
      return a.index - b.index;
    }

    return a.priority - b.priority;
  });

  return rowsWithPriority.map((row) => row.rowId);
};

export const splitSelectedRowsByType = ({
  selectedRows,
  parsedValues,
  selImportType,
  isAlphaNumericFn,
}) => {
  if (selImportType !== "multi") {
    return {
      pgRows: selectedRows,
      pfRows: [],
    };
  }

  const pgRows = [];
  const pfRows = [];

  for (let i = 0; i < selectedRows.length; i++) {
    const selectedRow = selectedRows[i];
    const item = getParsedRowByIdOrIndex(parsedValues, selectedRow);

    if (!item || !Array.isArray(item)) {
      continue;
    }

    if (isMultiRowPg(item, isAlphaNumericFn)) {
      pgRows.push(selectedRow);
    } else {
      pfRows.push(selectedRow);
    }
  }

  return {
    pgRows,
    pfRows,
  };
};

export const getConfirmRowDetails = ({ item, selImportType, isAlphaNumericFn }) => {
  const cfRaw = (item[15] || "").trimStart().trimEnd();
  const pIva = (item[9] || "").trimStart().trimEnd();

  let isPg = false;
  if (selImportType === "aricdesktop") {
    const rowType = cfRaw !== "" && pIva !== "" ? "N" : item[3];
    isPg = rowType === "S" ? false : true;
  } else {
    isPg = isMultiRowPg(item, isAlphaNumericFn);
  }

  const cf = isPg && cfRaw === "" ? pIva : cfRaw;

  return {
    cf,
    pIva,
    isPg,
    denominazione: item[1],
    codLegalRapp: item[28],
    codice: item[0],
  };
};
